import React, { Component } from 'react';
import { fonts, globalStyles } from '../../../theme/index.js';
import Bubble from '../../../components/Bubble.js';
import Button from '../../../components/Button.js';
import Text from '../../../components/Text.js';
import Modal from '../../../components/Modals/Modal.js';
import ModularFlexForm from './ModularFlexForm.js';
import Loader from '../../../components/Loader.js';
import Tooltip from '../../../components/Tooltip.js';
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import * as dates from "@simplybenefits/sb-dates";
import * as Services from '../../../services/index.js';
import DateInput from '../../../components/TextFields/DateInput.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class ModularFlexDesignForm extends Component {
  state = {
    unSavedChangesMade: false,
    showSaveMessageDialog: false,
    effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
    showEffectiveDateDialog: false,
    errors: {
      health: {
        gold: {
          healthcare: {},
          drugs: {},
          spendingAccounts: {}
        },
        silver: {
          healthcare: {},
          drugs: {},
          spendingAccounts: {}
        },
        bronze: {
          healthcare: {},
          drugs: {},
          spendingAccounts: {}
        }
      },
      dental: {
        gold: {},
        silver: {},
        bronze: {}
      },
      outOfCountry: {},
      efap: {},
      virtualHealthcare: {},
      financialAwareness: {},
      lifeInsurance: {},
      deathDismemberment: {},
      std: {},
      ltd: {},
      criticalIllness: {},
      dependentLife: {}
    }
  };

  /**
   * On Unmount, clear the auto save and do a final save
   */
  async componentWillUnmount() {
    if (this.state.unSavedChangesMade) {
      const confirm = window.confirm("Do you want to save your changes?");
      if (confirm) {
        await this._saveDesign();
      }
    }
  }
  _setChangesMadeFlag = () => {
    this.setState({
      unSavedChangesMade: true
    });
  };
  _validateEffectiveDate = async () => {
    const effectiveDateError = await Services.validateInput('effectiveDate', this.state.effectiveDate);
    await this.setState({
      effectiveDateError
    });
    if (effectiveDateError) {
      return false;
    }
    return true;
  };
  _saveBlueprint = async () => {
    if (this.props.currentAccountMeta.state >= 3 && !this.props.isMasterSite) {
      return null;
    }

    // if it's the master site, make sure we ask for an effective date
    if (this.props.isMasterSite) {
      const effectiveDateValid = await this._validateEffectiveDate();
      if (!effectiveDateValid) {
        return null;
      }
    }
    const success = await this.props.saveModularBlueprint(this.props.isMasterSite ? dates.getUTC(this.state.effectiveDate) : null);
    if (success) {
      this.setState({
        unSavedChangesMade: false,
        effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
        showEffectiveDateDialog: false
      });
    }
    return null;
  };
  _toggleEffectiveDateDialog = () => {
    this.setState({
      showEffectiveDateDialog: !this.state.showEffectiveDateDialog
    });
  };
  render() {
    const {
      isMasterSite,
      currentAccountMeta
    } = this.props;
    const whitelabel = this.props.whitelabel || {};
    const styles = {
      container: globalStyles.containerControlSite,
      content: globalStyles.content,
      contentBlock: globalStyles.contentBlock,
      saveBtn: {
        display: 'block',
        marginLeft: 'auto',
        marginTop: "20px !important"
      },
      header: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between"
      },
      headerTitleBlock: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
      },
      backBtn: {
        minWidth: "30px",
        padding: "2px",
        marginRight: "5px",
        marginLeft: "-5px"
      },
      table: {
        ...globalStyles.table,
        border: "2px solid #F1F1F1",
        backgroundColor: '#FFF'
      },
      scrollbar: globalStyles.scrollbar,
      tableHeading: {
        paddingTop: 10,
        paddingBottom: 10,
        fontFamily: fonts.type.heading
      },
      tableCell: {
        paddingTop: 10,
        paddingBottom: 10,
        fontFamily: fonts.type.light
      }
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.contentBlock
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.headerTitleBlock
    }, /*#__PURE__*/React.createElement(Button, {
      customStyle: styles.backBtn,
      onClick: this.props.goBack,
      transparent: true
    }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0"
    }, i18n.t(tokens.labels.planDesign.buildAQuote))), (isMasterSite || this.props.currentAccountMeta.state <= 3) && /*#__PURE__*/React.createElement(Button, {
      customStyle: {
        height: 50,
        width: 180,
        fontSize: 16,
        textTransform: "capitalize"
      },
      onClick: () => {
        // if we are saving a normal plan design from the master site then ask for an effective date
        if (isMasterSite && !this.props.isQuote && !this.props.isRevision) {
          this._toggleEffectiveDateDialog();
        } else {
          this._saveBlueprint();
        }
      },
      color: "primary"
    }, i18n.t(tokens.labels.planDesign.saveBlueprint))), this.props.selectedClass.description ? /*#__PURE__*/React.createElement(Tooltip, {
      tip: this.props.selectedClass.description,
      placement: "top",
      arrow: true,
      display: "inline-block"
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: `${i18n.t(tokens.titles.class)}: ${this.props.selectedClass.title}`,
      isSelected: true,
      clickable: false
    })) : /*#__PURE__*/React.createElement(Bubble, {
      label: `${i18n.t(tokens.titles.class)}: ${this.props.selectedClass.title}`,
      isSelected: true,
      clickable: false
    }), !isMasterSite && /*#__PURE__*/React.createElement(React.Fragment, null, currentAccountMeta.state === 4 && /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, i18n.t(tokens.labels.planDesign.planDesignUnderReview)), currentAccountMeta.state === 5 && /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, i18n.t(tokens.labels.planDesign.reviewFinishedNoPricing)), currentAccountMeta.state > 5 && /*#__PURE__*/React.createElement(Text, {
      color: "red"
    }, i18n.t(tokens.labels.planDesign.acceptPricingNoChanges))), /*#__PURE__*/React.createElement(ModularFlexForm, {
      blueprint: this.props.blueprint,
      errors: this.state.errors,
      isMasterSite: isMasterSite,
      isRevision: this.props.isRevision,
      classID: this.props.classID,
      specialityProductMetaConfigs: this.props.specialityProductMetaConfigs,
      saveModularBenefitInitData: this.props.saveModularBenefitInitData,
      saveModularField: this.props.saveModularField,
      whitelabel: whitelabel,
      setChangesMadeFlag: this._setChangesMadeFlag,
      accountMeta: this.props.currentAccountMeta,
      isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor
    }), (isMasterSite || currentAccountMeta.state <= 3) && /*#__PURE__*/React.createElement(Button, {
      customStyle: styles.saveBtn,
      onClick: () => {
        // if we are saving a normal plan design from the master site then ask for an effective date
        if (isMasterSite && !this.props.isQuote && !this.props.isRevision) {
          this._toggleEffectiveDateDialog();
        } else {
          this._saveBlueprint();
        }
      },
      color: "primary"
    }, i18n.t(tokens.labels.planDesign.saveBlueprint))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showSaveMessageDialog,
      onClose: () => {
        this.setState({
          showSaveMessageDialog: false,
          unSavedChangesMade: false
        });
      },
      title: i18n.t(tokens.labels.planDesign.changesMade),
      primaryButton: {
        label: "Save",
        onClick: async () => {
          // if we are saving a normal plan design from the master site then ask for an effective date
          if (isMasterSite && !this.props.isQuote && !this.props.isRevision) {
            await this._toggleEffectiveDateDialog();
          } else {
            await this._saveBlueprint();
          }
          this.setState({
            showSaveMessageDialog: false
          });
        }
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true
    }, i18n.t(tokens.labels.planDesign.unsavedChanges))), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showEffectiveDateDialog,
      onClose: this._toggleEffectiveDateDialog,
      title: "Set Effective Date",
      primaryButton: {
        label: "Submit",
        onClick: this._saveBlueprint
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, "Please provide the date you would like the change(s) to be effective:"), /*#__PURE__*/React.createElement(DateInput, {
      label: "Effective Date",
      value: this.state.effectiveDate,
      onChange: e => {
        this.setState({
          effectiveDate: e.target.value
        });
      },
      error: Boolean(this.state.effectiveDateError),
      helperText: this.state.effectiveDateError,
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, "By clicking Submit below, the changes made will be applied and effective on the date provided above. Back dated changes will have adjustments applied using current rates.")), this.props.loader?.isLoading && this.props.loader.type === 'container' && /*#__PURE__*/React.createElement(Loader, {
      isContainer: true
    }));
  }
}
export default ModularFlexDesignForm;